<template>
  <div
    :class="[
      'box-viewmore',
      {
        open
      }
    ]"
  >
    <div v-if="title" class="title-box v-line">
      <h2>{{ title }}</h2>
    </div>
    <div :ref="refName" :class="!isHidden ? 'box-content-hidden' : 'box-content'">
      <slot id="content" />
    </div>
    <div class="flex justify-center">
      <button class="btn-viewmore mr-0" @click="openView()" v-if="isHidden">
        <span>{{ getExpandLabel }}</span>
        <i
          class="icon icon-bor-triangle-down text-primary"
          :class="{ rotate: this.open }"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapseMenu',
  props: {
    title: {
      type: String,
      default: ''
    },
    minCollapse: {
      type: Number,
      default: 30
    },
    refName: {
      type: String,
      default: 'collapse-menu'
    }
  },
  data() {
    return {
      open: false,
      isHidden: true
    }
  },
  mounted() {
    this.getHeight()
  },
  computed: {
    getExpandLabel() {
      return this.open ? ' 閉じる' : '詳細を見る'
    }
  },
  methods: {
    getHeight() {
      const heightOfBox = this.$refs[this.refName].clientHeight
      if (heightOfBox < this.minCollapse) {
        this.isHidden = false
      } else {
        this.isHidden = true
      }
    },
    openView() {
      this.open = !this.open
      this.$emit('open', this.open)
    }
  },
  updated() {
    this.getHeight()
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
